import { render, staticRenderFns } from "./customerMgt.vue?vue&type=template&id=4f2d2bc8&scoped=true&"
import script from "./customerMgt.vue?vue&type=script&lang=js&"
export * from "./customerMgt.vue?vue&type=script&lang=js&"
import style0 from "./customerMgt.vue?vue&type=style&index=0&id=4f2d2bc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d2bc8",
  null
  
)

export default component.exports